import type { $Fetch } from 'nitropack'
import type { NuxtAxiosInstance } from '@/types/axios'
import {
  ProductSalesMode,
  type ProductDetailInfo,
  type ProductInfoQueryParams,
  type ProductPenaltyRuleGetParams,
  type ProductPenaltyRuleParams,
  type ProductPenaltyRuleResult,
} from '@/view-models/product'
import { ResponseCode, type ResultGenericVM, type ResultListGenericVM } from '@/view-models/common'
import type { ProductSeatsResponse } from '@/view-models/remark'

export async function getBranchProducts(axios: NuxtAxiosInstance, bid: string, query: any): Promise<{ data: any[] } & any> {
  if (!bid) {
    throw new Error('branch cant be empty')
  }
  const { size = 10, ...restQuery } = query

  const result = await axios.$get(`/pub/branch/${bid}/products`, { params: { ...restQuery, size } })

  return { ...result, data: result.data?.filter((product: any) => product.sales_mode !== ProductSalesMode.WineDelivery) || [] }
}

export async function getProductInfo(fetch: $Fetch, pid: number | string, params: ProductInfoQueryParams = {}) {
  const query = adaptObjectToSearchParams(params, { filter: (value: string | number) => value !== undefined && value !== null })
  const res = await fetch<ResultGenericVM<ProductDetailInfo>>(`/pub/product/${pid}/info`, {
    query: Object.fromEntries(query),
  })
  return res.data
}

export async function getProductPenaltyRule(fetch: $Fetch, pid: number | string, params: ProductPenaltyRuleParams) {
  const query: ProductPenaltyRuleGetParams = {
    currency_id: params.currencyId,
    payment_currency_id: params.paymentCurrencyId,
  }
  if (params.bookingTime) {
    query.booking_time = params.bookingTime
  }
  const res = await fetch<ResultGenericVM<ProductPenaltyRuleResult>>(`/pub/product/${pid}/penalty-rule`, { query })
  return res.data
}

export async function getProductSeats(
  fetch: $Fetch,
  pid: number | string,
  params: { bookingTime?: string; headcount?: number }
): Promise<ProductSeatsResponse[]> {
  const query = adaptObjectToSearchParams(params)
  const res = await fetch<ResultListGenericVM<ProductSeatsResponse>>(`/product/${pid}/seats`, { query: Object.fromEntries(query) })
  if (res.code === ResponseCode.SEATS_NOT_EXIST) {
    throw res
  }
  return res.data || []
}
